import Button from './ui/Button';
import { useState, useEffect, useRef } from 'react';
import { Alert, Spin } from 'antd';
import Smilehelper from '../utils/Smilehelper';
import get from 'lodash/get';
import { useStoreContext } from '../context/store';
import { DeleteOutlined } from '@ant-design/icons';

const Attachment = ({ value, onChange, t }) => {
    const fileInput = useRef();
    const [imgBase64, setImgBase64] = useState(get(value, 'src', ''));
    const [fileName, setFileName] = useState(get(value, 'fileName', ''));
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const { dispatch } = useStoreContext();

    useEffect(() => {
        if(imgBase64) {
          onChange({ ...value, src: imgBase64, score: null, fileName: fileName });
        }
      }, [imgBase64, fileName]);

    const resetAttach = () => {
      onChange({ ...value, src: undefined, fileName: undefined });
    }

    const handleAttachment = async (e) => {
      dispatch({
        type: 'ui.update',
        payload: {
          working: true,
        },
      });
      const file = e.target.files[0];
      setLoading(true);
      const reader = new FileReader();
      reader.addEventListener('loadend', () => setImgBase64(reader.result));
      reader.readAsDataURL(file);
      const formData = new FormData();
      formData.append('attachment', file);
      try {
          await Smilehelper.postFile(formData);
          setLoading(false);
          setFileName(file.name);
      } catch (error) {
          resetAttach();
          setError(error.response.data.attachment[0]);
          setLoading(false);
      }
      dispatch({
        type: 'ui.update',
        payload: {
          working: false,
        },
      });
    }

    const onClick = () => {
      if(error) {
        setImgBase64('');
        setError(false);
      }
      fileInput?.current?.click();
    }

    const handleDelete = () => {
      resetAttach();
      setImgBase64('');
    }

    return (
        <>
            <Button
              onClick={onClick}
              className='thin-button'
              disabled={imgBase64 && !error}
              style={{background: (imgBase64 && !error) ? '#8a8a8a' : undefined}}
            >
                {t('attach')}
            </Button>
            <input
                ref={fileInput}
                type="file"
                style={{ display: 'none' }}
                onClick={e => e.target.value = null}
                onChange={handleAttachment}
                accept='.png, .jpg, .jpeg'
            />

            {(imgBase64 && !error && !loading) && <div className='container-alert'>
                <Alert
                    message={fileName.length < 20 ? fileName : `${fileName.substring(0, 19)}...` }
                    type="success"
                    showIcon
                    action={ <DeleteOutlined onClick={handleDelete} /> }
                />
            </div>}

            <div className='upload-image'>
                {loading ? <Spin /> : ( error
                    ? <div className='container-alert'>
                        <Alert message={error} type="error" showIcon />
                    </div>
                    : (imgBase64 && <img src={imgBase64} alt='attached' width={300} height={230} />)
                )}
            </div>
        </>
    );
}

export default Attachment;